export const LMS_ROUTES = [
    '/user/module-list',
    '/user/pre-assessment',
    '/user/chapter-list',
    '/user/inclusive-course',
    '/user/post-chapter-assessment',
    '/user/post-module-feedback',
    '/user/post-module-assessment',
    '/user/post-course-assessment',
    '/user/post-course-feedback'
]
export const NOT_INCLUDE_HEDER_ROUTES = [
    '/user/pre-assessment',
    '/user/inclusive-course',
    '/user/post-chapter-assessment',
    '/user/post-module-feedback',
    '/user/post-module-assessment',
    '/user/post-course-assessment',
    '/user/post-course-feedback'
]